import { render, staticRenderFns } from "./todayPlayerPoint.vue?vue&type=template&id=7675a204&"
import script from "./todayPlayerPoint.vue?vue&type=script&lang=js&"
export * from "./todayPlayerPoint.vue?vue&type=script&lang=js&"
import style0 from "./todayPlayerPoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports